// Generated by purs version 0.13.8
"use strict";
var React_Basic = require("../React.Basic/index.js");
var React_Basic_Native_Generated = require("../React.Basic.Native.Generated/index.js");
var React_Basic_Native_Styles = require("../React.Basic.Native.Styles/index.js");
var ZAP_Dart_Client_Assets = require("../ZAP.Dart.Client.Assets/index.js");
var ZAP_Dart_Client_Components_EmptyPage = require("../ZAP.Dart.Client.Components.EmptyPage/index.js");
var sheet = {
    container: React_Basic_Native_Styles.staticStyles([ React_Basic_Native_Styles.flex(1) ])
};
var component = React_Basic.createComponent("About");
var about = function (info) {
    var render = function (props) {
        return React_Basic_Native_Generated.view()({
            style: sheet.container,
            children: [ ZAP_Dart_Client_Components_EmptyPage.emptyPage({
                image: ZAP_Dart_Client_Assets.emptyCatalog,
                message: {
                    primary: "Coming soon",
                    secondary: ""
                }
            }) ]
        });
    };
    return React_Basic.makeStateless(component)(render);
};
module.exports = {
    about: about
};
